var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41.761,
    height: 36.704,
    viewBox: "0 0 41.761 36.704",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3487",
    "data-name": "Rectangle 3487",
    width: 41.761,
    height: 36.704,
    fill: "#4188f2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6395",
    "data-name": "Groupe 6395",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5669",
    "data-name": "Trac\\xE9 5669",
    d: "M1.224,31.81H7.341v3.67A1.224,1.224,0,0,0,8.565,36.7H40.538a1.223,1.223,0,0,0,1.223-1.223V3.67a1.223,1.223,0,0,0-1.223-1.223H34.421V1.223a1.223,1.223,0,1,0-2.447,0V2.447h-6.2V1.223a1.223,1.223,0,1,0-2.447,0V2.447H17.211V1.223a1.223,1.223,0,1,0-2.447,0V2.447h-6.2A1.223,1.223,0,0,0,7.341,3.67v7.341c0,9.017-3.747,15.953-6.9,18.635a1.224,1.224,0,0,0,.783,2.164m38.091,2.447H9.788V31.81H33.2a1.223,1.223,0,0,0,.783-.284,22.577,22.577,0,0,0,5.334-7.877ZM9.788,4.894h4.975V6.117a1.223,1.223,0,1,0,2.447,0V4.894h6.117V6.117a1.223,1.223,0,1,0,2.447,0V4.894h6.2V6.117a1.223,1.223,0,1,0,2.447,0V4.894h4.894V9.788H9.788Zm-.021,7.34H39.293C39.017,20,36.038,26.1,32.718,29.363H4.007A29.442,29.442,0,0,0,9.767,12.234",
    transform: "translate(0)",
    fill: "#4188f2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/date-icon.382bb8463119b41ac752e6994bea88ee.svg";
export { ForwardRef as ReactComponent };